import * as rootMutationTypes from '@/store/mutation-types';

export default {

  radioUsers: (state, getters, rootState) => (problemId) => {
    return getters.teamsForProblem(problemId).reduce((all, team) => [...all, ...team.radioItems], []);
  },

  teamsForProblem: (state, getters, rootState) => (problemId) => {
    const problem = state.problems[`${problemId}`];
    const accesses = problem ? [...(problem.accesses || []), problem.affectTeam] : [];
    return (rootState[rootMutationTypes.GET_TEAMS.stateKey] || [])
      .filter(({ id }) => accesses.includes(id))
      .map(team => ({ ...team, radioItems: team.users }));
  },

};
